import { Avatar, Box, Stack } from '@mui/material';
import { DialogUI, CheckboxUI, ButtonUI } from '../Interface';
import { TagType } from '../../config/tag';
import { useEffect, useState } from 'react';

const TagListDialog = ({ dialogData, handleClose, allItems, linkedItems, onSave }) => {
  const { open, mode } = dialogData;
  const [selectedItems, setSelectedItems] = useState([]);

  useEffect(() => {
    if (open) {
      setSelectedItems(linkedItems);
    }
  }, [open]);

  const isSelected = (row) => selectedItems.some((item) => item.id === row.id);

  const toggleSelectedItem = (row) => {
    setSelectedItems((prev) =>
      prev.some((item) => item.id === row.id) ? prev.filter((item) => item.id !== row.id) : [...prev, row]
    );
  };

  const handleSave = () => {
    onSave(selectedItems);
    handleClose();
  };

  return (
    <DialogUI
      open={open}
      headerContent={mode === TagType.LABEL ? 'Címkék' : 'Matricák'}
      fullWidth
      onClose={handleClose}
      closeBtn
    >
      <Stack
        direction={mode === TagType.LABEL ? 'column' : 'row'}
        gap={mode === TagType.LABEL ? 0 : 1}
        flexWrap="wrap"
        mt={2}
      >
        {allItems.map((row) => {
          const selected = isSelected(row);

          return mode === TagType.LABEL ? (
            <Box key={row.id}>
              <CheckboxUI
                label={row.name}
                checked={selected}
                onChange={() => toggleSelectedItem(row)}
                sx={{ p: 0.2 }}
              />
            </Box>
          ) : (
            <Box
              key={row.id}
              onClick={() => toggleSelectedItem(row)}
              sx={{
                cursor: 'pointer',
                border: selected ? '3px solid #1976d2' : '3px solid transparent',
                borderRadius: 2,
                p: 0.5,
              }}
            >
              <Avatar
                sx={{
                  height: 100,
                  width: 100,
                  boxSizing: 'border-box',
                  textAlign: 'center',
                }}
                src={`${process.env.REACT_APP_API_URL}/${row.picture}`}
              >
                {row.name}
              </Avatar>
            </Box>
          );
        })}
      </Stack>

      <Box mt={2} textAlign="center">
        <ButtonUI text="Mentés" onClick={handleSave} className="bg-success" />
      </Box>
    </DialogUI>
  );
};

export default TagListDialog;
